import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Layout-only styles. Per-state and per-phase colors come from data
// and land via inline `style` on each pill.
//
// Strip layout mirrors the prototype's interactive phase timeline
// at MayFirmOS.html:1366-1378: gap of 2px between pills, no wrapping
// (horizontal scroll is the fallback when the row is too narrow).
export const strip = style({
  display: "flex",
  gap: "2px",
  overflow: "auto",
  margin: 0,
  padding: 0,
  listStyle: "none",
});

// Each pill is the prototype's compact, uppercase phase tab. Bold
// 9px text, tight 6px/2px padding, 4px corners, 60px floor width.
// Letter-spacing matches the prototype's 0.3 for the sidebar-pill feel.
export const pill = style({
  flex: "1 1 0",
  minWidth: "60px",

  paddingBlock: "6px",
  paddingInline: "2px",
  borderRadius: "4px",
  borderWidth: "1px",
  borderStyle: "solid",

  fontFamily: vars.font.body,
  fontSize: "9px",
  fontWeight: 700,
  lineHeight: 1.2,
  letterSpacing: "0.3px",
  textAlign: "center",
  textTransform: "uppercase",

  transition: "all 0.15s",
});
